<template>
  <component :is="kind" @click="$emit('click', $event)">
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { BtnOrange, BtnOutlined } from '~/components/ui/Buttons'

export default defineComponent({
  components: {
    BtnOutlined,
    BtnOrange,
  },
  props: {
    kind: {
      type: String,
      required: false,
      default: 'BtnOrange',
      validator: (value: string) =>
        ['BtnOrange', 'BtnOutlined'].includes(value),
    },
  },
  emits: ['click'],
})
</script>

<style lang="scss" scoped></style>
